
// export const BaseUrl ='https://3j6lq1k0-7007.inc1.devtunnels.ms/api';
export const BaseUrl ='https://syraenergy.com/api';
export const ShareBaseUrl = 'https://syraenergy.com';